@import '@evisort/eds-tokens/index.css';

/*
 * Base reset the design system relies on.
 *
 * Only 19 of the package's stylesheets set `box-sizing` themselves; the rest
 * were written against a global `* { box-sizing: border-box }` that the
 * application injected through the EDS 1.0 uinix system. Once the package is
 * consumed as a built artifact that reset is no longer guaranteed to be there,
 * and without it every padded element renders wider than designed.
 *
 * The application already applies the same rule, so this changes nothing there.
 */
*,
*::before,
*::after {
  box-sizing: border-box;
}
